import { useInfiniteQuery } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { GetDealOptionsParams } from "types/crm/deal";

interface UseQueryOptions {
  enabled?: boolean;
}


export const useContactDealOptions = (
  contactUuid: string,
  params: Omit<GetDealOptionsParams, "page"> = {},
  options: UseQueryOptions = {},
) => {
  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: dealQueryKeys.options(contactUuid, params),
    queryFn: ({ pageParam }) =>
      dealApi.getDealOptions(contactUuid, { ...params, page: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      lastPage.last ? undefined : lastPage.page + 1,
    enabled: (options.enabled ?? true) && !!contactUuid,
  });

  return {
    deals: data?.pages.flatMap((p) => p.content) ?? [],
    isLoading,
    isFetchingMore: isFetchingNextPage,
    hasMore: !!hasNextPage,
    onLoadMore: fetchNextPage,
    totalElements: data?.pages[0]?.totalElements ?? 0,
  };
};
